import React, { useState } from 'react';

interface ChatInputProps {
  onSendMessage: (message: string) => void; // Fonction pour envoyer le message au parent
  disabled?: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, disabled = false }) => {
  const [currentMessage, setCurrentMessage] = useState<string>(''); // Suivi du texte actuel

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentMessage(e.target.value); // Mettre à jour la valeur de l'entrée
  };

  const handleSendMessage = () => {
    if (currentMessage.trim()) {
      onSendMessage(currentMessage); // Envoyer le message au composant parent
      setCurrentMessage(''); // Réinitialiser l'entrée après l'envoi
    }
  };

  return (
    <div className="chat-input-container">
      <input
        type="text"
        value={currentMessage}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault(); // facultatif, évite un saut de ligne si besoin
            handleSendMessage();
          }
        }}
        disabled={disabled}
        placeholder="Type a message..."
        className="chat-message-input"
      />

      <button type="button" className="chat-tool-button" disabled={disabled}>
        <i className="la la-paperclip"></i>
      </button>
      <button type="button" onClick={handleSendMessage} className="chat-send-button" disabled={disabled || !currentMessage.trim()}>
        <i className='las la-paper-plane'>  </i>
      </button>
    </div>
  );
};

export default ChatInput;
